import {
    monitoringResultsTableFirstMoverFilter,
    monitoringResultsTableOutOfStockFilter,
    monitoringResultsTableRestockedFilter,
    monitoringResultsTableUnderPriceFilter
} from "../../@signals";


export default function iconFiltersColumn() {
    return [{
        name: 'hasFirstMover', label: 'First Mover',
        options: {
            display: 'excluded',
            filterList: monitoringResultsTableFirstMoverFilter.value,
            customBodyRowRender: value => value ? 'Yes' : 'No'
        }
    }, {
        name: 'hasUnderPrice', label: 'Under Price',
        options: {
            display: 'excluded',
            filterList: monitoringResultsTableUnderPriceFilter.value,
            customBodyRowRender: (value, { haveMainPrice }) => value && haveMainPrice ? 'Yes' : 'No'
        }
    }, {
        name: 'hasRestocked', label: 'Restocked',
        options: {
            display: 'excluded',
            filterList: monitoringResultsTableRestockedFilter.value,
            customBodyRowRender: value => value ? 'Yes' : 'No'
        }
    }, {
        name: 'hasOOS', label: 'Out of Stock',
        options: {
            display: 'excluded',
            filterList: monitoringResultsTableOutOfStockFilter.value,
            customBodyRowRender: value => value ? 'Yes' : 'No'
        }
    }]
}